//
// Enable the websocket when a login is successful and disable it again when
// there is a logout request. I would have put this in a saga but didn't see
// a way to access the websocket from within a saga.
//
import { AnyAction } from 'redux';
import { WebSocketClient } from 'wss/WebSocketClient';
import { Actions as SessionActions } from 'actions/sessionActions';

export const websocketEnabler =
    (websocketClient: WebSocketClient) => (/*store: Store<any>*/) => {
        return (next: (a: AnyAction) => void) => (action: AnyAction) => {
            if (typeof action.type === 'string') {
                if (action.type === SessionActions.LOGIN_SUCCESS) {
                    websocketClient.enable(true);
                }
                else if (action.type === SessionActions.LOGOUT_REQUEST) {
                    websocketClient.enable(false);
                }
            }
            return next(action);
        };
    };